import { render, staticRenderFns } from "./CreateSyntheticMediaModal.vue?vue&type=template&id=557d8a04&scoped=true"
import script from "./CreateSyntheticMediaModal.vue?vue&type=script&lang=js"
export * from "./CreateSyntheticMediaModal.vue?vue&type=script&lang=js"
import style0 from "./CreateSyntheticMediaModal.vue?vue&type=style&index=0&id=557d8a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d8a04",
  null
  
)

export default component.exports